// extracted by mini-css-extract-plugin
module.exports = {"map":"Map_map__2FLcJ","staticMap":"Map_staticMap__1HV89"};